"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
require("./Contact.css");
require("../../Styles/Page.css");
const fontawesome_free_solid_1 = require("@fortawesome/fontawesome-free-solid");
const free_brands_svg_icons_1 = require("@fortawesome/free-brands-svg-icons");
const faEnvelopeIcon = fontawesome_free_solid_1.faEnvelope;
const faGithubIcon = free_brands_svg_icons_1.faGithub;
const faLinkedinIcon = free_brands_svg_icons_1.faLinkedin;
const Contact = () => {
    return react_1.default.createElement("div", { className: "Contact", id: "page" },
        "  Contact Me",
        react_1.default.createElement("div", null,
            react_1.default.createElement("a", { href: "mailto:careers@jdoran.dev" },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faEnvelopeIcon }),
                react_1.default.createElement("span", null, "Careers Email: careers@jdoran.dev"))),
        react_1.default.createElement("div", null,
            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faEnvelopeIcon }),
            react_1.default.createElement("span", null, "Business Email: business@jdoran.dev")),
        react_1.default.createElement("div", null,
            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faEnvelopeIcon }),
            react_1.default.createElement("span", null, "Personal Email: johndoran@jdoran.dev")),
        react_1.default.createElement("div", null,
            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faGithubIcon }),
            react_1.default.createElement("span", null, "Github: github.com/jc22dora")),
        react_1.default.createElement("div", null,
            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faLinkedinIcon }),
            react_1.default.createElement("span", null, "LinkedIn: linkedin.com/in/johncdoran")));
};
exports.default = Contact;
